<template>
  <div class="mc-wrapper">
    <div class="mc-container">
      <div class="mc-boutiques">
        <section class="mc-boutiques__tabs mc-tabs mc-tabs--fr">
          <div class="mc-tabs__button-wrapper" v-if="boutiques.length > 1">
            <ul class="mc-tabs__list">
              <li v-for="(items, city, index) in boutiques" class="mc-tabs__item" :class="tabShow==index?'isActive':''" @click="tabShow=index" :id="'tab'+index">
                <button class="mc-tabs__button js-button-tab" :data-name="'content'+index" type="button">
                  {{ city }}
                </button>
              </li>
              <li class="mc-tabs__glide" :style="tabGlide"></li>
            </ul>
          </div>
          <div class="mc-tabs__body-wrapper">
            <div v-for="(items, city, index) in boutiques" class="mc-tabs__body" :class="tabShow==index?'isActive':''" :id="'content'+index">
              <ul class="mc-boutiques__list">
                <li v-for="item in items" class="mc-boutiques__item mc-boutique-card" :class="mapOpen[item.id]?'isMapOpen':''">
                  <div class="mc-boutique-card__title">
                    {{ item.name }}
                  </div>
                  <div class="mc-boutique-card__info" v-html="item.address.TEXT">

                  </div>
                  <div class="mc-boutique-card__bottom">
                    <div class="mc-boutique-card__bottom-column">
                      <a @click="tel_open(item.phone)">
                        {{ item.phone }}
                      </a>
                    </div>
                    <div class="mc-boutique-card__bottom-column">
                      <button class="mc-boutique-card__map-button js-map-button" type="button" @click="mapOpen[item.id] = !mapOpen[item.id]">
                                                    <span class="mc-boutique-card__button-text" data-alt="Свернуть">
                                                        {{mapOpen[item.id]?'Свернуть':'Развернуть карту'}}
                                                    </span>
                        <svg class="mc-boutique-card__button-icon" width="14" height="14" viewBox="0 0 14 14">
                          <use xlink:href="/assets/svg/sprite.svg#arrow-chevron"></use>
                        </svg>
                      </button>
                    </div>
                    <yandex-map v-if="item.map"  class="mc-boutique-card__map"
                        :settings="{location: {        center: [item.map[1], item.map[0]],        zoom: 15,      },    }"
                        width="100%"
                        height="500px"
                    >
                      <yandex-map-default-scheme-layer/>
                      <yandex-map-default-features-layer/>
                      <yandex-map-default-marker :settings="{ coordinates: [item.map[1], item.map[0]] }"/>
                    </yandex-map>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  YandexMap,
  YandexMapDefaultSchemeLayer,
  YandexMapDefaultFeaturesLayer,
  YandexMapDefaultMarker,
} from 'vue-yandex-maps';
import urlopen from "@/mixin/urlopen.vue";

export default {
  data: () => ({
    tabShow: 0,
    tabGlide: {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    },
    mapOpen: {},
    settings: {
      apiKey: '', // Индивидуальный ключ API
      lang: 'ru_RU', // Используемый язык
      coordorder: 'latlong', // Порядок задания географических координат
      debug: false, // Режим отладки
      version: '2.1' // Версия Я.Карт
    },
    options: {
      /*iconLayout: 'default#image',
      iconImageHref: "/img/map-target.svg",
      iconImageSize: [47, 74],
      iconImageOffset: [-47, -74]*/
    },
    mapSettings: {
      location: {
        center: [37.617644, 55.755819],
        zoom: 9,
      },
    }
  }),
  mixins: [urlopen],
  computed: {
  ...mapGetters([
      'boutiques',
      'boutiquesLoading',
      'boutiquesError',
      'boutiquesLoaded'
    ])
  },
  created() {
    this.fetchBoutique();
  },
  mounted() {
    setTimeout(() => {
      this.setTabActive(0);
    },1000)
  },
  components: {YandexMap,
    YandexMapDefaultSchemeLayer,
    YandexMapDefaultFeaturesLayer,
    YandexMapDefaultMarker},
  watch: {
    tabShow(newValue, oldValue) {
      this.setTabActive(newValue);
    }
  },
  methods: {
    ...mapActions([
      'fetchBoutique'
    ]),
    getPositionRelativeToParent(element) {
      var parent = element.parentElement;
      var parentRect = parent === null || parent === void 0 ? void 0 : parent.getBoundingClientRect();
      var elementRect = element.getBoundingClientRect();
      return {
        left: elementRect.left - parentRect.left,
        top: elementRect.top - parentRect.top
      };
    },
    setTabActive(newValue) {
      let tabItem = document.getElementById('tab'+newValue);
      if (!tabItem)
        return;
      let relativePosition = this.getPositionRelativeToParent(tabItem);
      this.tabGlide.left = relativePosition.left + "px";
      this.tabGlide.top = relativePosition.top + "px";
      this.tabGlide.width = tabItem.offsetWidth + "px";
      this.tabGlide.height = tabItem.offsetHeight + "px";
    }
  },
}
</script>

